var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container materialGRIDetail" },
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.historyBack },
        }),
      ]),
      _c(
        "el-tabs",
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("material.searchBox_top") } },
            [
              _c(
                "div",
                { staticClass: "searchBox_top" },
                [
                  _vm.$route.query.type === "newCreate" || _vm.DetailForm.isSave
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.gri_add,
                              expression: "gri_add",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.saveDetail(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.saveDraft")))]
                      )
                    : _vm._e(),
                  _vm.DetailForm.isSubmit
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.gri_add,
                              expression: "gri_add",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.saveDetail(2)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.submit")))]
                      )
                    : _vm._e(),
                  _vm.DetailForm.isExamine
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.gri_approval,
                              expression: "gri_approval",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.showApproval = true
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("material.showApproval")))]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form",
                {
                  ref: "DetailForm",
                  attrs: {
                    model: _vm.DetailForm,
                    rules: _vm.DetailRules,
                    "label-width": "150px",
                    inline: "",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("material.GRICode"),
                                prop: "fiveBitCode",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: _vm.$t(
                                    "material.DisplayAfterSave"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.DetailForm.fiveBitCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.DetailForm,
                                      "fiveBitCode",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "DetailForm.fiveBitCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.status"),
                                prop: "status",
                              },
                            },
                            [
                              _c("ic-select", {
                                attrs: {
                                  table: "TM_FIVE_BIT_CODE",
                                  field: "STATUS",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.DetailForm.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.DetailForm, "status", $$v)
                                  },
                                  expression: "DetailForm.status",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.createBy"),
                                prop: "createUserName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", disabled: "" },
                                model: {
                                  value: _vm.DetailForm.createUserName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.DetailForm,
                                      "createUserName",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "DetailForm.createUserName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Category1",
                                prop: "categoryLevel1Id",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    disabled: _vm.fiveBitCode,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeCategory1($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.DetailForm.categoryLevel1Id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.DetailForm,
                                        "categoryLevel1Id",
                                        $$v
                                      )
                                    },
                                    expression: "DetailForm.categoryLevel1Id",
                                  },
                                },
                                _vm._l(_vm.categoryList1, function (item) {
                                  return _c("el-option", {
                                    key: item.tmCategoryId,
                                    attrs: {
                                      label: item.name,
                                      value: item.tmCategoryId,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Category2",
                                prop: "categoryLevel2Id",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    disabled: _vm.fiveBitCode,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeCategory2($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.DetailForm.categoryLevel2Id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.DetailForm,
                                        "categoryLevel2Id",
                                        $$v
                                      )
                                    },
                                    expression: "DetailForm.categoryLevel2Id",
                                  },
                                },
                                _vm._l(_vm.categoryList2, function (item) {
                                  return _c("el-option", {
                                    key: item.tmCategoryId,
                                    attrs: {
                                      label: item.name,
                                      value: item.tmCategoryId,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Category3",
                                prop: "categoryLevel3Id",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    disabled: _vm.fiveBitCode,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeCategory3($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.DetailForm.categoryLevel3Id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.DetailForm,
                                        "categoryLevel3Id",
                                        $$v
                                      )
                                    },
                                    expression: "DetailForm.categoryLevel3Id",
                                  },
                                },
                                _vm._l(_vm.categoryList3, function (item) {
                                  return _c("el-option", {
                                    key: item.tmCategoryId,
                                    attrs: {
                                      label: item.name,
                                      value: item.tmCategoryId,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("material.fiveBitCodeName"),
                                prop: "fiveBitCodeName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { maxlength: "50", clearable: "" },
                                model: {
                                  value: _vm.DetailForm.fiveBitCodeName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.DetailForm,
                                      "fiveBitCodeName",
                                      $$v
                                    )
                                  },
                                  expression: "DetailForm.fiveBitCodeName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("material.describe"),
                                prop: "describe",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  maxlength: "100",
                                  autosize: "",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.DetailForm.describe,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.DetailForm, "describe", $$v)
                                  },
                                  expression: "DetailForm.describe",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.createDate"),
                                prop: "createDate",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  clearable: "",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.DetailForm.createDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.DetailForm, "createDate", $$v)
                                  },
                                  expression: "DetailForm.createDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("material.fromEffectiveDate"),
                                prop: "fromEffectiveDate",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.DetailForm.fromEffectiveDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.DetailForm,
                                      "fromEffectiveDate",
                                      $$v
                                    )
                                  },
                                  expression: "DetailForm.fromEffectiveDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("material.invalidDate"),
                                prop: "invalidDate",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.DetailForm.invalidDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.DetailForm, "invalidDate", $$v)
                                  },
                                  expression: "DetailForm.invalidDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "material.inventoryCountingFrequency"
                                ),
                                prop: "inventoryCountingFrequency",
                              },
                            },
                            [
                              _c("ic-select", {
                                attrs: {
                                  table: "TM_FIVE_BIT_CODE",
                                  field: "INVENTORY_COUNTING_FREQUENCY",
                                  clearable: "",
                                },
                                model: {
                                  value:
                                    _vm.DetailForm.inventoryCountingFrequency,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.DetailForm,
                                      "inventoryCountingFrequency",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "DetailForm.inventoryCountingFrequency",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("material.menuType"),
                                prop: "menuType",
                              },
                            },
                            [
                              _c("ic-select", {
                                attrs: {
                                  table: "TM_FIVE_BIT_CODE",
                                  field: "MENU_TYPE",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.DetailForm.menuType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.DetailForm, "menuType", $$v)
                                  },
                                  expression: "DetailForm.menuType",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("material.storageCategory"),
                                prop: "storageCategory",
                              },
                            },
                            [
                              _c("ic-select", {
                                attrs: {
                                  table: "TM_FIVE_BIT_CODE",
                                  field: "STORAGE_CATEGORY",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.DetailForm.storageCategory,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.DetailForm,
                                      "storageCategory",
                                      $$v
                                    )
                                  },
                                  expression: "DetailForm.storageCategory",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "UOM", prop: "uom" } },
                            [
                              _c("ic-select", {
                                attrs: {
                                  table: "TM_FIVE_BIT_CODE",
                                  field: "UOM",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.DetailForm.uom,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.DetailForm, "uom", $$v)
                                  },
                                  expression: "DetailForm.uom",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("material.standardCopiesUom"),
                                prop: "standardCopiesUom",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm._f("toFixed")(
                                    _vm.DetailForm.standardCopiesUom,
                                    2
                                  ),
                                  onkeyup:
                                    "this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : ''",
                                  maxlength: "20",
                                },
                                model: {
                                  value: _vm.DetailForm.standardCopiesUom,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.DetailForm,
                                      "standardCopiesUom",
                                      $$v
                                    )
                                  },
                                  expression: "DetailForm.standardCopiesUom",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("material.isDisplayBtrReport"),
                                prop: "isDisplayBtrReport",
                              },
                            },
                            [
                              _c("ic-select", {
                                attrs: {
                                  clearable: "",
                                  table: "COMMON",
                                  field: "YES_NO",
                                },
                                on: { change: _vm.isDisplayBtrReportChange },
                                model: {
                                  value: _vm.DetailForm.isDisplayBtrReport,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.DetailForm,
                                      "isDisplayBtrReport",
                                      $$v
                                    )
                                  },
                                  expression: "DetailForm.isDisplayBtrReport",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              class: !_vm.isDisabled ? "is-required" : "",
                              attrs: {
                                label: _vm.$t("material.btrUsageArea"),
                                prop: "btrUsageArea",
                              },
                            },
                            [
                              _c("ic-select", {
                                attrs: {
                                  table: "TM_FIVE_BIT_CODE",
                                  field: "BTR_USAGE_AREA",
                                  clearable: "",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.DetailForm.btrUsageArea,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.DetailForm,
                                      "btrUsageArea",
                                      $$v
                                    )
                                  },
                                  expression: "DetailForm.btrUsageArea",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              class: !_vm.isDisabled ? "is-required" : "",
                              attrs: {
                                label: _vm.$t("material.btrUnitMeasurement"),
                                prop: "btrUnitMeasurement",
                              },
                            },
                            [
                              _c("ic-select", {
                                attrs: {
                                  table: "TM_FIVE_BIT_CODE",
                                  field: "BTR_UNIT_MEASUREMENT",
                                  clearable: "",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.DetailForm.btrUnitMeasurement,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.DetailForm,
                                      "btrUnitMeasurement",
                                      $$v
                                    )
                                  },
                                  expression: "DetailForm.btrUnitMeasurement",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("common.approvalLog") } },
            [
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: {
                    data: _vm.workFlowLogList,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "createDate",
                      label: _vm.$t("common.OperationTime"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFormatFilter")(
                                    scope.row.createDate,
                                    "YYYY-MM-DD HH:mm:ss"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "operatorName",
                      label: _vm.$t("common.OperatorName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "action",
                      label: _vm.$t("common.PedagogicalOperation"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "comments",
                      label: _vm.$t("common.opinion"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("supplierManage.approvalWindow"),
            visible: _vm.showApproval,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showApproval = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "info",
              staticClass: "form_border",
              attrs: { model: _vm.info, "label-width": "120px" },
            },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.auditor"),
                            placeholder: "",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.username,
                              callback: function ($$v) {
                                _vm.username = $$v
                              },
                              expression: "username",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("common.approvalTime"),
                            placeholder: "",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.date,
                              callback: function ($$v) {
                                _vm.date = $$v
                              },
                              expression: "date",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("common.approvalResults"),
                            placeholder: "",
                            prop: "approvalType",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "1" },
                              model: {
                                value: _vm.info.approvalType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.info, "approvalType", $$v)
                                },
                                expression: "info.approvalType",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.pass")))]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "2" },
                              model: {
                                value: _vm.info.approvalType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.info, "approvalType", $$v)
                                },
                                expression: "info.approvalType",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.noPass")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("common.approvalRemarks"),
                            placeholder: "",
                            prop: "approvalDescription",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { type: "textarea" },
                            model: {
                              value: _vm.info.approvalDescription,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "approvalDescription", $$v)
                              },
                              expression: "info.approvalDescription",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveDetail(3)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.submit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showApproval = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("category-dialog", {
        attrs: { "is-show": _vm.showDialog, "create-fun": _vm.onConfirm },
        on: {
          "update:isShow": function ($event) {
            _vm.showDialog = $event
          },
          "update:is-show": function ($event) {
            _vm.showDialog = $event
          },
          hideDialog: function ($event) {
            _vm.showDialog = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }